import type {GlobalState} from 'types/store';
import {getBool as getBoolPreference} from 'mattermost-redux/selectors/entities/preferences';
import {Preferences} from 'mattermost-redux/constants';
import {type Channel} from '@mattermost/types/channels';

export const getGMChannelShowPreference = (state: GlobalState, channelId: Channel['id'], fallbackValue = false) =>
    getBoolPreference(state, Preferences.CATEGORY_GROUP_CHANNEL_SHOW, channelId, fallbackValue);
